<div class='d-flex'>
  <div class=''>
    <div class='form-field full-width pb'>
      <p-floatlabel variant="on">
        <input name='name'
               [(ngModel)]='userData.name'
               id='name'
               maxlength='30'
               minlength='5'
               pInputText
               class='full-width'
               size='30'
               type='text'
               [customPattern]='usernamePattern'
               formInlineError='auth.errors'
               fieldName='Username'
               disableAutocomplete
               required data-testid="name-input">
        <label for='name' class='label'>{{ 'auth.username' | translate }} *</label>
      </p-floatlabel>
    </div>

    <div class='form-field full-width pb'>
      <p-floatlabel variant="on">
        <input name='email'
               #email
               [(ngModel)]='userData.email'
               id='email'
               pInputText
               type='email'
               class='full-width'
               formInlineError='auth.errors'
               [customPattern]='emailRegex'
               fieldName='Email'
               disableAutocomplete
               required data-testid="email-input">
        <label for='email' class='label'>{{ 'auth.email' | translate }} *</label>
      </p-floatlabel>
    </div>

    <div class='form-field full-width pb'>
      <p-floatlabel variant="on">
        <input
          id='phoneNumber'
          pInputText
          [(ngModel)]='userData.userPhoneDTO.phoneNumber'
          name='phoneNumber'
          class='full-width'
          [required]='phoneNumberRequired'
          [disabled]='phoneNumberDisabled'
          formInlineError='auth.errors'
          type='text' data-testid="phone-number-input">
        <label class='label'
               for='phoneNumber'>{{ 'auth.phoneNumber' | translate }} {{ phoneNumberRequired ? '*' : '' }}</label>
      </p-floatlabel>
    </div>

    <div class='form-field full-width pb' *ngIf='(!isNewUser && isUserAccountValid) && showPasswords'>
      <p-floatlabel variant="on">
        <p-password name='oldPassword'
                    [(ngModel)]='userData.oldPassword'
                    [toggleMask]='true'
                    id='oldPassword'
                    type='password'
                    class='full-width'
                    inputStyleClass='w-100'
                    minlength='5'
                    maxlength='50'
                    formInlineError='auth.errors'
                    disableAutocomplete
                    required data-testid="old-password-password-input">
        </p-password>
        <label for='oldPassword' class='label'>{{ 'auth.oldPassword' | translate }} *</label>
      </p-floatlabel>
    </div>

    <div class='form-field full-width pb'>
      <p-floatlabel variant="on">
        <p-select [autoDisplayFirst]='false'
                    [options]='languages'
                    name='lang'
                    [(ngModel)]='userData.lang'
                    [style]="{'width': '100%'}"
                    id='lang' data-testid="lang-select">
        </p-select>
        <label class='label' for='lang'>{{ 'auth.language' | translate }}</label>
      </p-floatlabel>
    </div>

    <div class='form-field full-width pb' *ngIf='(isNewUser || isUserAccountValid) && showPasswords'>
      <p-floatlabel variant="on">
        <p-password name='password'
                    [(ngModel)]='userData.password'
                    #pw='ngModel'
                    id='password'
                    [toggleMask]='true'
                    [promptLabel]="'auth.choosePassword' | translate"
                    [mediumRegex]='mediumPasswordRegex'
                    [strongRegex]='strongPasswordRegex'
                    [maxLength]='maximumPasswordLength'
                    [customPattern]='passwordRegex'
                    styleClass='full-width'
                    inputStyleClass='w-100'
                    type='password'
                    formInlineError='auth.errors.password'
                    disableAutocomplete
                    required data-testid="password-password-input">
          <ng-template pTemplate='footer'>
            <auth-password-rules [password]='userData.password'>
            </auth-password-rules>
          </ng-template>
        </p-password>
        <label for='password' class='label'>{{ 'auth.password' | translate }} *</label>
      </p-floatlabel>
    </div>

    <div *ngIf='(isNewUser || isUserAccountValid) && showPasswords'>
      <div class='form-field full-width pb'>
        <p-floatlabel variant="on">
          <p-password name='passwordConfirmation'
                      [(ngModel)]='passwordConfirmation'
                      [toggleMask]='true'
                      [promptLabel]="'auth.choosePassword' | translate"
                      [mediumRegex]='mediumPasswordRegex'
                      [strongRegex]='strongPasswordRegex'
                      [maxLength]='maximumPasswordLength'
                      [customPattern]='passwordRegex'
                      id='passwordConfirmation'
                      #pwc='ngModel'
                      type='password'
                      formInlineError='auth.errors.passwordConfirmation'
                      styleClass='full-width'
                      inputStyleClass='w-100'
                      disableAutocomplete
                      required data-testid="password-confirmation-password-input">
            <ng-template pTemplate='footer'>
              <auth-password-rules [password]='passwordConfirmation'>
              </auth-password-rules>
            </ng-template>
          </p-password>
          <label for='passwordConfirmation' class='label'>{{ 'auth.passwordConfirmation' | translate }} *</label>
        </p-floatlabel>
      </div>
      <div class='form-field'
           *ngIf='(pwc.invalid || userData?.password !== passwordConfirmation) && (pwc.dirty || pwc.touched)'>
        <p class='color-danger'
           *ngIf='userData?.password !== passwordConfirmation'>{{ 'auth.errors.passwordConfirmation.passwordConfirmationMatchError' | translate }}</p>
      </div>
    </div>

    <div *ngIf='isNewUser || (!isNewUser && (userData.email !== emailValue))'>
      <div class='full-width pb ms-1 mt-2 mb-2'>
        <p-floatlabel variant="on" class="d-flex gap-2 align-items-start">
          <p-checkbox
            name='confirmCheckbox'
            id='confirmCheckbox'
            customRequiredTrue='ConfirmCheckbox'
            #confirmCheckbox='ngModel'
            [(ngModel)]='isChecked'
            [binary]='true'
            formInlineError='auth.errors'
           data-testid="confirm-checkbox">
          </p-checkbox>
          <h4>{{ 'auth.confirmEmailCheck' | translate }} *</h4>
        </p-floatlabel>
      </div>
    </div>

  </div>
</div>
